module.exports = __webpack_public_path__ + "static/img/sx3.887c81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/sx/sx3.png
// module id = kE0b
// module chunks = 0